import { CbhIcon, type IconType, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

interface InfoCardProps {
  iconType: IconType;
  title: string;
  description: string;
}

export function InfoCard(props: InfoCardProps) {
  const { iconType, title, description } = props;

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background.primary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(4),
      })}
    >
      <Stack spacing={3}>
        <Stack direction="row" spacing={3} alignItems="center">
          <CbhIcon type={iconType} size="small" />
          <Text semibold variant="body1">
            {title}
          </Text>
        </Stack>
        <Text variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Text>
      </Stack>
    </Box>
  );
}
